import { Input, Checkbox } from "@/components/ui/form";

export const SlotDate = ({ day }) => {
    return (
        <>
            <td className="px-1 py-2">
                <Input
                    name={`${day}.Dates[0].startDate`}
                    size="sm"
                    type="date"
                    label="Start date"
                    hideLabel={true}
                />
            </td>
            <td className="px-1 py-2">
                <Input
                    name={`${day}.Dates[0].endDate`}
                    size="sm"
                    type="date"
                    label="End date"
                    hideLabel={true}
                />
            </td>
            <td className="px-2 py-2">
                <Checkbox
                    name={`${day}.Dates[0].allDay`}
                    size="sm"
                    label={"All day"}
                    hideLabel={true}
                    className="mt-1.5"
                />
            </td>
        </>
    );
};
